import { Tag } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const manualCsv: IIngestionSourceData = {
  isEcom: false,
  isAutomated: false,
  displayName: "Manual",
  listInventory: {
    linkHref: "/listInventory/manual",
    icon: Tag
  }
}

export default manualCsv

